export class HandledError extends Error {
    constructor(message: string, public originalError: Error) {
        super(message);
        this.name = 'HandledError';
    }
}